"use strict";

(() => {
    const headerCartButtons = document.querySelectorAll(".menu-tools__link--cart > a");
    const cartCloseButton = document.querySelector(".drawer-cart__header .drawer-close");
    const cartContainerClose = document.querySelector(".drawer-mask");
    const cartContent = document.getElementById("drawer-cart-content");

    const initializeWishlistButtons = () => {
        // Select all wishlist toggle buttons
        var wishlistButtons = document.querySelectorAll(".drawer-cart .wishlist-toggle__button");

        if (wishlistButtons) {
            var wishlistItems = window.retrieveLocalStorage("wishlist");

            wishlistButtons.forEach(function (button) {
                var productHandle = button.dataset.handle;

                // Check if the product is already in the wishlist and add 'active' class
                if (wishlistItems) {
                    wishlistItems.forEach(function (item) {
                        if (item === productHandle) {
                            button.classList.add("active");
                        }
                    });
                }

                // Add event listener for wishlist toggle
                button.addEventListener("click", function (event) {
                    event.preventDefault();

                    var lineItemId = button.parentElement.parentElement.dataset.lineItemId;

                    if (button.classList.contains("active")) {
                        // Remove from wishlist
                        window.removeFromLocalStorage("wishlist", productHandle);
                        button.classList.remove("active");
                        document.dispatchEvent(new CustomEvent("RemovedFromWishlist", { detail: { handle: productHandle } }));
                    } else {
                        // Add to wishlist
                        window.appendToLocalStorage("wishlist", productHandle);
                        button.classList.add("active");
                        document.dispatchEvent(new CustomEvent("AddedToWishlist", { detail: { handle: productHandle } }));

                        // If item is in cart, remove it
                        if (lineItemId) {
                            fetch("/cart/change.js", {
                                method: "POST",
                                headers: { "Content-type": "application/json" },
                                body: JSON.stringify({ quantity: 0, line: lineItemId })
                            })
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function () {
                                if(location.pathname.includes("wishlist")) {
                                    location.reload()
                                } else {
                                    window.updateCartDrawer();
                                    window.countCartItems();
                                    updateCartTotal();
                                }
                            });
                        }
                    }

                    window.updateWishlistCounter();
                });
            });
        }
    }

    headerCartButtons.forEach((cartButton) => {
        cartButton.addEventListener("click", (event) => {
            event.preventDefault();

            if(document.body.classList.contains("bs-ike-005")) {
                window.openCartDrawer();
                window.updateCartDrawer();
            } else {
                window.location.href = "/cart";
            }
        });
    });

    if (cartCloseButton) {
        cartCloseButton.addEventListener("click", () => {
            document.body.classList.remove("drawer-cart-open", "drawer-open");
            document.body.style.removeProperty("overflow")
        });
    }

    if (cartContainerClose) {
        cartContainerClose.addEventListener("click", () => {
            document.body.classList.remove("drawer-cart-open", "drawer-open");
            document.body.style.removeProperty("overflow")
        });
    }

    window.openCartDrawer = () => {
		if(document.body.classList.contains("bs-ike-005")) {
			const bodyElement = document.body;
			const openDrawer = () => {
				bodyElement.classList.add("drawer-open", "drawer-cart-open");
				document.body.style.overflow = "hidden";
				setTimeout(() => bodyElement.classList.add("mask-visible"), 125);
			};

			if (bodyElement.classList.contains("drawer-open")) {
				window.closeAllDrawers(openDrawer);
			} else {
				openDrawer();
			}
		}
    };

    const updateCartTotal = () => {
        const targetElement = document.querySelector(".drawer-cart .drawer__total");
        const headerCartIconCount = document.querySelector(".cart-counter .count");

        if(!headerCartIconCount || !targetElement) return;

        if(!headerCartIconCount.innerHTML) {
            targetElement.innerHTML = 0;
        } else {
            targetElement.innerHTML = headerCartIconCount.innerHTML;
        }
    };

    const updateCart = (updates) => {
        return fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates })
        }).then(response => response.json()).finally(() => {
            window.countCartItems();
        });
    };

    const updateCartItemQuantity = (inputElement) => {
        const newQuantity = inputElement.value;
        const productId = inputElement.closest(".cart-quantity").dataset.id;

        updateCart({ [productId]: newQuantity })
            .then(window.updateCartDrawer)
            .catch(console.error);
    };

    const initializeCartDrawerQuantityControls = () => {
        const quantityControls = cartContent.querySelectorAll(".cart-quantity");

        quantityControls.forEach((control) => {
            const quantityInput = control.querySelector("input");
            let quantityValue = parseInt(quantityInput.value, 10);
            const incrementButtons = control.querySelectorAll(".increment");

            incrementButtons.forEach((button) => {
                button.addEventListener("click", (event) => {
                    event.preventDefault();
                    quantityValue += button.classList.contains("down") ? -1 : 1;
                    quantityValue = Math.max(quantityValue, 0);
                    quantityInput.value = quantityValue;
                    updateCartItemQuantity(quantityInput);
                });
            });
        });

        cartContent.querySelectorAll("input").forEach((input) => {
            input.addEventListener("keyup", () => {
                clearTimeout(window.inputDelay);
                window.inputDelay = setTimeout(() => updateCartItemQuantity(input), 500);
            });
        });
    };

    const initializeCartDrawerRemoveButtons = () => {
        cartContent.querySelectorAll(".cart__item--remove > a").forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault();
                const productId = button.closest(".cart__item").querySelector(".cart-quantity").dataset.id;

                updateCart({ [productId]: 0 })
                    .finally(window.updateCartDrawer)
                    .catch(console.error);
            });
        });
    };

    window.updateCartDrawer = () => {
        const cartItemsContainer = cartContent.querySelector(".cart-items");
        const cartTotalContainer = document.getElementById("drawer-cart-totals");
        const cartFooter = document.getElementById("drawer-cart-footer");
        const upsellSection = document.querySelector(".dynamic-upsell");

        cartItemsContainer.innerHTML = "";
        cartContent.classList.add("content-loading");
        upsellSection.classList.add("content-loading");

        fetch(`${window.Shopify.routes.root}cart`)
            .then(response => response.text())
            .then(cartHTML => {
                let isCartEmpty = cartHTML.includes("<!--[cart-empty]-->");
                cartItemsContainer.innerHTML = isCartEmpty
                    ? cartHTML.split("<!--[cart-empty]-->").pop().split("<!--[/cart-empty]-->")[0]
                    : cartHTML.split("<!--[cart-items]-->").pop().split("<!--[/cart-items]-->")[0];

                cartTotalContainer.innerHTML = isCartEmpty ? "" : cartHTML.split("<!--[cart-total]-->").pop().split("<!--[/cart-total]-->")[0];

                cartFooter.classList.toggle("hide-content", isCartEmpty);
            })
            .finally(() => {
                cartContent.classList.remove("content-loading");
                upsellSection.classList.remove("content-loading");
                initializeCartDrawerQuantityControls();
                initializeCartDrawerRemoveButtons();
                updateCartTotal();
                initializeWishlistButtons();
                document.dispatchEvent(new CustomEvent("rerenderCart"));
            })
            .catch(console.error);
    };

    document.addEventListener('upsellProductAdded', () => {
        const quantityControls = document.querySelectorAll(".dynamic-upsell__item .cart-quantity input");

        updateCartItemQuantity(quantityControls[0]);
    });
})();
